const filter = [
  {
    service: {
      folder: 'user',
      file: 'Users',
      relationship: ''
    },
    listLabel: 'name',
    label: 'Leitor',
    itemValue: 'id',
    itemText: 'name',
    id: 'user_id',
    query: {
      ativo: true
    }
  }
]

export default filter
